module.exports = __webpack_public_path__ + "static/media/ico-video.46f31ce5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ico-video.svg
// module id = 336
// module chunks = 0